import * as React from 'react';
import InputBase from '@mui/material/InputBase';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';
import Label from './Label.jsx';

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { copyTextToClipboard } from '../../../../utils';
import styled from 'styled-components';

export default function Text({
	slug = '',
	label = '',
	value = null,
	placeholder = '',
	onChange = (e) => {},
	onBlur = (e) => {},
	error = false,
	copiable = false,
	readOnly = false
}) {

	const handleChange = (value) => {
		onChange(value);
	};

	const handleCopyValue = () => {
		copyTextToClipboard(null, value)
	}

	return (
		<ThemeProvider theme={backYouTheme}>
			<Wrapper>
				{label && <Label htmlForValue={"text-input-" + slug} label={label} />}
				<InputBase
					readOnly={readOnly}
					error={error}
					value={value}
					placeholder={placeholder}
					onChange={(e) => handleChange(e.target.value)}
					onBlur={(e) => onBlur(e)}
					className={`text-gc-dark-blue font-weight-bold ${error ? 'is-invalid' : ''}`}
					id={"text-input-" + slug}

					sx={{
						height: 42, 
						backgroundColor: '#FFF',
						padding: '0 1rem',
						border: '1px solid #ced4da',

						'&:hover': {
							border: '1px solid #004753',
						},
					}}

					startAdornment={
						copiable ? <InputAdornment position="start">
							<IconButton
								aria-label="Copy"
								onClick={handleCopyValue}
								edge="start"
							>
								<i className="fa-regular fa-copy" style={{ fontSize: '.9rem' }}></i>
							</IconButton>
						</InputAdornment> : null
					}
				/>
			</Wrapper>
		</ThemeProvider>
	);
}

const Wrapper = styled.div`
  input {
    padding: 0;
  }
`;